/**
 * Парсит дату в русском формате (dd.MM.yyyy)
 * @param {string|Date} value - значение даты
 * @returns {Date|null} - объект Date или null
 */
export function parseRuDate(value) {
    if (!value) return null;

    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }

    const str = String(value).trim();
    if (!str) return null;

    const parts = str.split('.');
    if (parts.length !== 3) return null;

    const day = Number(parts[0]);
    const month = Number(parts[1]);
    const year = Number(parts[2]);

    if (!day || !month || !year) return null;

    const date = new Date(year, month - 1, day);
    return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Проверяет, попадает ли дата в указанный диапазон
 * @param {string|Date} dateValue - проверяемая дата
 * @param {Object|null} dateRange - диапазон с полями start и end
 * @returns {boolean}
 */
export function isDateInRange(dateValue, dateRange) {
    if (!dateRange) return true;

    const date = parseRuDate(dateValue);
    if (!date) return false;

    const start = new Date(dateRange.start);
    const end = new Date(dateRange.end);

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    date.setHours(12, 0, 0, 0);

    return date >= start && date <= end;
}

/**
 * Преобразует значение datepicker в диапазон дат
 * @param {Date|Date[]|null} value - значение от datepicker
 * @param {string} mode - режим ('range' или 'single')
 * @returns {Object|null} - объект с полями start и end или null
 */
export function getDateRangeFromPicker(value, mode = 'range') {
    if (mode === 'range') {
        if (!Array.isArray(value) || value.length !== 2) return null;

        const start = parseRuDate(value[0]);
        const end = parseRuDate(value[1]);

        if (!start && !end) return null;

        return {
            start: start || end,
            end: end || start,
        };
    }

    const single = parseRuDate(value);
    if (!single) return null;

    return {
        start: single,
        end: single,
    };
}